import { RebalancingProposalMember } from './rebalancing-proposal-member.entity';

export class RebalancingProposalEntity {
  public caseId!: string;
  public caseNumber!: string;
  public caseTypeName!: string;
  public caseStatusLabel!: string;
  public isOverdue!: boolean;
  public teamId!: string;
  public teamName!: string;
  public fromMember!: RebalancingProposalMember;
  public toMember!: RebalancingProposalMember;
  public alternates!: RebalancingProposalMember[];
  public rationale!: string;
}
